module.exports = __webpack_public_path__ + "static/media/cockroach(16).7aba2ea6.PNG";